var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.118,
    height: 34.09,
    viewBox: "0 0 14.118 34.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M1167.733,464.816a2.725,2.725,0,1,1,2.725-2.724A2.725,2.725,0,0,1,1167.733,464.816Z",
    transform: "translate(-1160.674 -459.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M1157.423,472.67a2.409,2.409,0,0,1,2.407-2.411h9.305a2.409,2.409,0,0,1,2.406,2.411v8.456h0a1.206,1.206,0,0,1-2.411,0h0v-6.033a.418.418,0,0,0-.835,0v8.541h0v12.818a1.672,1.672,0,1,1-3.344,0V483.635h0a.464.464,0,0,0-.927,0h0v12.818a1.672,1.672,0,1,1-3.344,0V475.093a.418.418,0,0,0-.836,0v6.4h0a1.206,1.206,0,1,1-2.411,0,1.115,1.115,0,0,1,.006-.115c0-.053-.006-.106-.006-.161Z",
    transform: "translate(-1157.423 -464.035)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.2faa8c1e5cc0e327ac949b934ba4f9ec.svg";
export { ForwardRef as ReactComponent };